import { FormControlLabel, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomCheckbox from '../forms/theme-elements/CustomCheckbox';
import ShowContainer from './ShowContainer';
import CusTooltip from './CusTooltip';

export default function CusCheckbox({
  label = '',
  checked = false,
  title = '',
  name = '',
  onChange = undefined,
  prevIcon = null,
  checkBoxSx,
  fontWeight,
  variant = 'h3',
  tooltipText,
  onClick,
  disabled
}) {
  const { t } = useTranslation();

  if (title) {
    return (
      <label
        onClick={onClick}
        style={{
          display: 'flex',
          width: 'fit-content',
          cursor: 'pointer',
          userSelect: 'none',
          alignItems: 'center'
        }}>
        <CustomCheckbox
          sx={checkBoxSx}
          disabled={disabled}
          name={name}
          checked={checked}
          onChange={onChange}
        />
        <Typography variant={variant}>{t(title)}</Typography>
      </label>
    );
  }

  return (
    <FormControlLabel
      style={{ userSelect: 'none', margin: 0 }}
      onClick={onClick}
      control={
        <CustomCheckbox
          sx={checkBoxSx}
          disabled={disabled}
          name={name}
          checked={checked}
          onChange={onChange}
        />
      }
      label={
        <ShowContainer condition={label || tooltipText || prevIcon}>
          <Stack display={'flex'} gap={1} direction={'row'}>
            <Typography
              justifyContent={'center'}
              display={'flex'}
              gap={1}
              m={0}
              fontWeight={fontWeight}
              lineHeight={'115%'}>
              {prevIcon} {typeof label == 'string' ? t(label) : label}
            </Typography>

            <ShowContainer condition={tooltipText}>
              <CusTooltip text={tooltipText} />
            </ShowContainer>
          </Stack>
        </ShowContainer>
      }
    />
  );
}
